/**
 *
 * Button.js
 *
 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
 * otherwise it'll render a link with an onclick
 */

import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { StyledLink, StyledButton } from './styles';
/**
 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
 * otherwise it'll render a link with an onclick
 * @param {Object} props Properties for the controller
 */
function ButtonComponent(props) {
  const { href, onClick, className, handleRoute, secondary, color, disabled, component, children } =
    props;
  // Render an anchor tag
  let button = (
    <StyledLink component="button" href={href} onClick={onClick} {...props} customstyle={className}>
      {Children.toArray(children)}
    </StyledLink>
  );

  // If the Button has a handleRoute prop, we want to render a button
  if (handleRoute) {
    if (!secondary) {
      button = (
        <StyledButton
          variant="contained"
          color={color || 'primary'}
          onClick={handleRoute}
          disabled={disabled}
          component={component}
          customstyle={className}
          disableElevation
        >
          {Children.toArray(children)}
        </StyledButton>
      );
    } else {
      button = (
        <StyledButton
          variant="outlined"
          color={color || 'primary'}
          onClick={handleRoute}
          disabled={disabled}
          component={component}
          customstyle={className}
        >
          {Children.toArray(children)}
        </StyledButton>
      );
    }
  }

  return button;
}

ButtonComponent.propTypes = {
  handleRoute: PropTypes.func,
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  secondary: PropTypes.bool,
  disabled: PropTypes.bool,
  component: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  color: PropTypes.string,
};

export default ButtonComponent;
